import React, { Component } from 'react'
import FunctionBlock from '../Common/FunctionBlock'

export default class extends Component {
  render() {
    return (
      <FunctionBlock
        style={{ margin: '60px auto 80px' }}
        title="智能流量投放"
        content="针对婚礼行业数据，研发智能投放助手。根据商家设置的推广内容，精准定向潜在客户，大幅提升客资效率。真正实现一键内容设置，实时精准投放。大面积覆盖潜在用户，针对目标用户多次曝光，全自动获客！"
        funs={
          <img
            style={{
              width: 780,
              margin: '50px auto 30px auto',
              display: 'block'
            }}
            src="//qnm.hunliji.com/o_1dpuqmqsu97c1lnn1pns1o6mmdv9.png"
          />
        }
      />
    )
  }
}
